<template>
    <div :style="{ 'transform': `translateY(${translate}px)` }">
        <slot></slot>
    </div>
</template>

<script>

export default {
    props: {
        depth: {
            type: Number,
            required: true,
        },
        relative: {
            type: Boolean,
            default: false,
        },
    },

    data() {
        return {
            translate: 0,
        };
    },

    mounted() {
        window.addEventListener('scroll', this.onScroll);
        window.addEventListener('resize', this.onScroll);

        this.onScroll();
    },

    beforeUnmount() {
        window.removeEventListener('scroll', this.onScroll);
        window.removeEventListener('resize', this.onScroll);
    },

    methods: {
        onScroll() {
            let { scrollY } = window;
            if (this.relative) {
                let rect;
                if (this.$parent && this.$parent.rect) {
                    ({ rect } = this.$parent);
                } else {
                    rect = this.$el.getBoundingClientRect();
                }

                const delta = rect.top + rect.height + (window.innerHeight / 2);
                scrollY -= delta;
            }

            const translate = -(scrollY * this.depth);
            this.translate = translate > 0 ? Math.max(-100, translate) : Math.min(100, translate);
        },
    },
};
</script>
